// doctors.service.ts
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

// Optional Interface
// export interface Doctor {
//   id?: number;
//   name: string;
//   specialty?: string;
//   phone?: string;
//   address?: string;
//   notes?: string;
//   created_at?: string;
//   updated_at?: string;
// }

@Injectable({ providedIn: 'root' })
export class DoctorsService {
  private base = `${environment.Server_URL}/doctors`;

  constructor(private http: HttpClient) {}

  // GET /doctors?per_page=&page=
getAll(perPage = 10, page = 1, isDoctor?: boolean): Observable<any> {
  let params = new HttpParams()
    .set('per_page', perPage.toString())
    .set('page', page.toString());

  if (isDoctor !== undefined) {
    params = params.set('is_doctor', isDoctor ? '1' : '0');
  }

  return this.http.get<any>(this.base, { params });
}

  // GET /doctors/{id}
  getById(id: number): Observable<any> {
    return this.http.get<any>(`${this.base}/${id}`);
  }

  // POST /doctors
  create(payload: any /* | Doctor */): Observable<any> {
    return this.http.post<any>(this.base, payload);
  }


update(id: number, payload: FormData | any): Observable<any> {
  const isFormData = payload instanceof FormData;

  if (isFormData) {
    payload.append('_method', 'PUT'); // ✨ ده يخلي Laravel يفهم إن الريكوست update
    return this.http.post(`${this.base}/${id}`, payload);
  }

  return this.http.put(
    `${this.base}/${id}`,
    payload,
    { headers: { 'Content-Type': 'application/json' } }
  );
}
  // DELETE /doctors/{id}
  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.base}/${id}`);
  }

search(q = '', isDoctor?: boolean): Observable<any> {
  let params = new HttpParams();

  if (q) params = params.set('q', q);
  if (isDoctor !== undefined) params = params.set('is_doctor', isDoctor ? '1' : '0');


  return this.http.get<any>(`${this.base}/search`, { params });
}

}
